import { TErrorData } from '../update-capabilities.type';

/** Estados que expone `sm-scheduling-ms` para una carga masiva de agendas. */
export type TBulkScheduleUploadStatus =
  | 'PENDING'
  | 'PROCESSING'
  | 'COMPLETED'
  | 'FAILED'
  | 'NOT_LOADED';

/**
 * Respuesta de `GET /scheduler/bulk-future-schedules/latest`.
 *
 * `errors` todavía no lo entrega el backend: el detalle por fila queda en el
 * `resultado.xlsx`. Se declara con la misma forma que usa la carga de
 * capacidades para que integrar el endpoint real no implique cambios de tipos.
 */
export type TBulkScheduleUpload = {
  readonly uploadId: string;
  readonly fileName?: string;
  /** Usuario SAP que ejecutó la carga. */
  readonly createdBy?: string;
  readonly createdAt?: string;
  readonly lastProcessDate?: string;
  readonly reportAvailable?: boolean;
  readonly status: TBulkScheduleUploadStatus;
  readonly totalRecords: number;
  readonly processedRecords: number;
  readonly successRecords: number;
  readonly duplicateRecords: number;
  readonly errorRecords: number;
  /** Registros no creados: duplicados y errores de procesamiento. */
  readonly failedRecords?: number;
  readonly failureReason?: string | null;
  readonly errors?: Record<string, TErrorData>;
};

/** Respuesta de `POST /scheduler/bulk-future-schedules`. */
export type TBulkScheduleUploadAccepted = {
  readonly uploadId: string;
  readonly status?: string;
  readonly message?: string;
};

/** Etiqueta visible del estado de la última carga (frame "Estados de carga"). */
export enum BulkScheduleProccessStatus {
  FAILED = 'Fallido',
  COMPLETED = 'Carga exitosa',
  PARTIAL = 'Carga con errores',
  PROCESSING = 'En proceso',
}

/** Variante de color del chip de estado. */
export type TBulkScheduleStatusTheme = 'success' | 'partial' | 'danger';

/**
 * Fila de resumen de la última carga. Siempre se pinta: cuando todavía no hay
 * cargas el diseño muestra la tabla con guiones en cada celda.
 */
export type TBulkScheduleCheckData = {
  /** Usuario SAP que ejecutó la carga. */
  readonly user: string;
  /** Fecha en formato dd/MM/yyyy. */
  readonly date: string;
  /** Hora en formato HH:mm:ss. Vacía cuando no hay carga. */
  readonly time: string;
  /** `null` cuando no hay carga: la celda muestra guiones en vez del chip. */
  readonly status: BulkScheduleProccessStatus | null;
  readonly theme: TBulkScheduleStatusTheme | null;
  readonly totalRecords: string;
  readonly successRecords: string;
  readonly failedRecords: string;
};

/** Placeholder de celda vacía. */
export const BULK_SCHEDULE_EMPTY_CELL = '----';
